// Site configuration - Injected during scaffold build
// This file is automatically generated and should not be edited manually

// Validate required environment variables in production
const requiredEnvVars = [
  'VITE_SUPABASE_URL',
  'VITE_SUPABASE_ANON_KEY',
  'VITE_CLERK_PUBLISHABLE_KEY',
  'VITE_EVENT_ID',
] as const;

const missingEnvVars = requiredEnvVars.filter(
  (key) => !import.meta.env[key]
);

if (missingEnvVars.length > 0 && import.meta.env.PROD) {
  throw new Error(
    `Missing required environment variables: ${missingEnvVars.join(', ')}`
  );
}

export const siteConfig = {
  eventId: import.meta.env.VITE_EVENT_ID || 'local-dev',
  eventSlug: import.meta.env.VITE_EVENT_SLUG || 'local-event',
  tenantId: import.meta.env.VITE_TENANT_ID || 'local-tenant',
  portalApiUrl: import.meta.env.VITE_PORTAL_API_URL || 'http://localhost:3000/api',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '',
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
} as const;

export type SiteConfig = typeof siteConfig;
